interface ErrorStateProps {
  error: string | Error;
  onRetry?: () => void;
  message?: string;
}

export function ErrorState({ error, onRetry, message }: ErrorStateProps) {
  const errMsg = typeof error === "string" ? error : error.message;
  return (
    <div className="error-state">
      <span className="material-symbols-outlined error-icon">error_outline</span>
      <h3>{message || "Đã có lỗi xảy ra"}</h3>
      <p className="error-detail">{errMsg}</p>
      {onRetry && (
        <button className="btn-retry" onClick={onRetry}>
          <span className="material-symbols-outlined">refresh</span>
          Thử lại
        </button>
      )}
    </div>
  );
}
